import Scorm12API from '../Scorm12API';

window.Scorm12API = Scorm12API;
